import { FAQ } from '../../utils/constants';
import { hasPermission } from '../../utils';
import enums from '@/utils/enums';
export default {
  computed: {
    faqItems() {
      return this.$store.getters[FAQ.GET_FAQS];
    },
    faqLoading() {
      return this.$store.getters[FAQ.GET_FAQS_LOADING];
    },
    faqError() {
      return this.$store.getters[FAQ.GET_FAQS_ERROR];
    }
  },
  methods: {
    async getFaqs() {
      if (!hasPermission(enums.supportViewProfiles)) return;
      await this.$store.dispatch(FAQ.FETCH_FAQS);
    },
    async getProductData(product) {
      const params = {
        filter: {
          code: product.code,
          externalSourceId: product.id
        },
        desiredFields: {
          code: 1,
          tourUrl: 1,
          status: 1,
          lastUpdate: 1,
          stage: 1
        }
      };
      const productUrl = `${process.env.CRUD_API_GET}/product`;
      const result = await this.requestService(productUrl, 'GET', { params, localErrorHandling: true});
      return result.items[0] || null;
    },
    goToFaq(item) {
      this.$router.push({ name: 'faq', params: { faq: item } });
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/modules/faq.js